module.exports = __webpack_public_path__ + "img/img10.4d940652.png";